import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { LoginComponent } from './features/auth/pages/login/login.component';
import { RegisterComponent } from './features/auth/pages/register/register.component';
import { roleGuard } from './core/guards/role.guard';
import { authGuard } from './core/guards/auth.guard';
import { UserRole } from './core/enums/user-role.enum';
import { verificationGuard } from './core/guards/verification.guard';

export const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [verificationGuard] },
    { path: 'auth/login', component: LoginComponent },
    { path: 'auth/register', component: RegisterComponent },
    {
      path: 'auth/forgot-password',
      loadComponent: () => import('./features/auth/pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
    },
    {
      path: 'auth/reset-password',
      loadComponent: () => import('./features/auth/pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
    },
    { 
      path: 'auth/complete-profile', 
      loadComponent: () => import('./features/auth/pages/complete-profile/complete-profile.component').then(m => m.CompleteProfileComponent),
      canActivate: [authGuard]
    },
    {
      path: 'verification',
      loadComponent: () => import('./features/auth/pages/verification/verification.component').then(m => m.VerificationComponent),
      canActivate: [authGuard]
    },
    
    // Área Administrativa (ADMIN e EVENT_ADMIN)
    {
      path: 'admin',
      loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES),
      canActivate: [roleGuard, verificationGuard],
      data: { roles: [UserRole.ADMIN] }
    },

    // Área do Organizador (EVENT_ADMIN apenas)
    {
      path: 'organizer',
      loadChildren: () => import('./features/organizer/organizer.routes').then(m => m.ORGANIZER_ROUTES),
      canActivate: [authGuard, roleGuard, verificationGuard],
      data: { roles: [UserRole.EVENT_ADMIN] }
    },

    // Área do Atleta (ATHLETE e ADMIN para suporte)
    {
      path: 'portal',
      loadChildren: () => import('./features/portal/portal.routes').then(m => m.PORTAL_ROUTES),
      canActivate: [roleGuard, verificationGuard],
      data: { roles: [UserRole.ATHLETE, UserRole.EVENT_ADMIN, UserRole.ADMIN] }
    },

    // Rotas de Eventos Públicas
    { 
      path: 'events', 
      loadComponent: () => import('./features/events/pages/event-list/event-list.component').then(m => m.EventListComponent) 
    },
    { 
      path: 'events/new', 
      loadComponent: () => import('./features/events/pages/event-form/event-form.component').then(m => m.EventFormComponent),
      canActivate: [authGuard, verificationGuard]
    },
    {
      path: 'events/:id',
      loadComponent: () => import('./features/events/pages/event-detail/event-detail.component').then(m => m.EventDetailComponent)
    },

    // Termos de Uso — públicos
    {
      path: 'termos',
      loadComponent: () => import('./features/legal/terms-of-use/terms-of-use.component').then(m => m.TermsOfUseComponent)
    },

    // Política de Privacidade (LGPD) — pública
    {
      path: 'privacidade',
      loadComponent: () => import('./features/legal/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
    },

    { path: '**', redirectTo: '' }
];
